// src/features/documents/components/StatusBadge.tsx
import { Badge } from '@/components/ui/badge';
import type { ConversionStatus } from '../types';

const statusVariant: Record<ConversionStatus, 'success' | 'warning' | 'danger' | 'secondary'> = {
  ready: 'success',
  done: 'success',
  processing: 'warning',
  pending: 'secondary',
  failed: 'danger',
  skipped: 'secondary',
};

export function StatusBadge({ status }: { status: string | null }) {
  if (!status) return <span className="text-muted-foreground">—</span>;

  const variant = statusVariant[status as ConversionStatus] ?? 'secondary';

  return (
    <Badge variant={variant} className="text-[11px] font-medium">
      {status}
    </Badge>
  );
}
